"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializationUtils = void 0;
var RoomHierarchyUtils_1 = require("./RoomHierarchyUtils");
var SnapBackUtils_1 = require("./SnapBackUtils");
/**
 * Contains utility functions that can be used to handle room related things
 * when serializing and deserializing the core state.
 */
exports.SerializationUtils = {
    getRoomDimensionsFromLegacyComponents: RoomHierarchyUtils_1.getRoomDimensionsFromLegacyComponents,
    getChildrenOfRoomAndScene: RoomHierarchyUtils_1.getChildrenOfRoomAndScene,
    snapEntitiesToClosestPlace: SnapBackUtils_1.snapEntitiesToClosestPlace,
};
//# sourceMappingURL=SerializationUtils.js.map